export default __webpack_public_path__ + "assets/no-results.d0b1554c.svg";